import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { LoginWithEmailAddress } from './api'; // Modifié ici
import LoginButton from './LoginButton';
import './Connexion.css';

function Connexion() {
    const animationRef = useRef([]);
    const [displayName, setDisplayName] = useState(''); // Remplacé ici
    const [loading, setLoading] = useState(false);
    const [showRectangle, setShowRectangle] = useState(false);
    const [showRobert, setShowRobert] = useState(false);
    const [showLine, setShowLine] = useState(false);
    const [showTexte, setShowTexte] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [, setError] = useState('');
    const [password, setPassword] = useState(''); // Remplacé ici

    const navigate = useNavigate();

    useEffect(() => {
        const timers = [
            setTimeout(() => setShowRectangle(true), 1100),
            setTimeout(() => setShowRobert(true), 2000),
            setTimeout(() => setShowLine(true), 2000),
            setTimeout(() => setShowTexte(true), 2000),
            setTimeout(() => setShowLogin(true), 2100),
        ];

        return () => timers.forEach(timer => clearTimeout(timer));
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
    
        try {
            const loginResponse = await LoginWithEmailAddress(displayName, password); 
    
            console.log('Réponse de connexion:', loginResponse);
    
            if (loginResponse.data.LoginResult.SessionTicket && loginResponse.data.LoginResult.PlayFabId) {
                const sessionTicket = loginResponse.data.LoginResult.SessionTicket;
                const playFabId = loginResponse.data.LoginResult.PlayFabId;
    
                localStorage.setItem('playFabId', playFabId);
                localStorage.setItem('sessionTicket', sessionTicket);
    
                navigate('/Accueil', { state: { displayName } });
            } else {
                setError('Nom d\'utilisateur ou mot de passe incorrect.');
            }
        } catch (error) {
            console.error('Une erreur est survenue lors de la connexion :', error);
            setError('Une erreur est survenue lors de la connexion. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="Connexion">
            {/* Contenu de la page Frame 52 */}
            <div className="Rectangle56"></div>
            <div className="Rectangle100"></div>
            <div className="Rectangle102"></div>
            <div className="Rectangle103"></div>
            <div className="Rectangle114"></div>
            <div className="Rectangle109"></div>
            <div className="Rectangle110"></div>
            <div className="Rectangle108"></div>
            <div className="Rectangle107"></div>
            <div className="Rectangle112"></div>
            <div className="Rectangle104"></div>
            <div className="Rectangle101"></div>
            <div className="Rectangle701"></div>
            <div className="Rectangle80"></div>
            <div className="Rectangle78"></div>
            <div className="Rectangle28"></div>
            <div className="Rectangle86"></div>
            <div className="Rectangle29"></div>
            <div className="Rectangle111"></div>
            <div className="Rectangle105"></div>
            <div className="Rectangle106"></div>
            <div className="Rectangle120"></div>
            <div className="Int">.Int</div>
            <div className="Credits"></div>
            <div className="Rectangle8"></div>
            <div className="Image2"></div>
            <div className="Image3"></div>
            <div className={`Rectangle88 ${showRectangle ? 'show' : ''}`}></div>
            <div className={`Rectangle89 ${showRobert ? 'show' : ''}`}></div>
            <div className={`Rectangle90 ${showRobert ? 'show' : ''}`}></div>
            <div className={`Rectangle91 ${showRectangle ? 'show' : ''}`}></div>
            <div className={`Line2 ${showLine ? 'show' : ''}`}></div>
            <div className={`Texte1 ${showTexte ? 'show' : ''}`}>
                Connectez-vous pour une expérience des plus mémorables et des plus sensationnelles.
            </div>
            <div className={`Logo ${showLine ? 'show' : ''}`}></div>

            <div className="login-form-container">
                {!loading && (
                    <form onSubmit={handleLogin} className="login-form">
                        <p className={`create-account-link ${showLogin ? 'show' : ''}`}>
                            Pas encore de compte? <Link to="/CreerCompte">Créer un compte</Link>
                        </p>
                        <LoginButton showLogin={showLogin} handleLogin={handleLogin} />
                    </form>
                )}
            </div>

            <div className={`text-input-container ${showLogin ? 'show' : ''}`}>
                <div className={`Rectangle1 ${showLogin ? 'show' : ''}`}></div>
                <input
                    type="text"
                    placeholder="Adresse email" // Vous pouvez remplacer ceci par un autre placeholder si nécessaire
                    className={`text-input ${showLogin ? 'show' : ''}`}
                    value={displayName} // Utilisé ici
                    onChange={(e) => setDisplayName(e.target.value)} // Utilisé ici
                />
                  <input
                    type="password"
                    placeholder="Mot de passe" // Vous pouvez remplacer ceci par un autre placeholder si nécessaire
                    className={`text-input ${showLogin ? 'show' : ''}`}
                    value={password} // Utilisé ici
                    onChange={(e) => setPassword(e.target.value)} // Utilisé ici
                />
            </div>

            

                 {/* Animations */}
                 <div className="animation-container">
                <dotlottie-player
                    ref={el => animationRef.current[0] = el}
                    src="https://lottie.host/8a81eaba-238c-4097-a547-1715c0e104b0/EP2Q1DsE1I.json"
                    background="transparent"
                    speed="0.9"
                    style={{ width: '382px', height: '523px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container1">
                <dotlottie-player
                    ref={el => animationRef.current[1] = el}
                    src="https://lottie.host/e13c996f-9946-42fa-a21d-43d66d2ccb9b/hqWm54jf3r.json"
                    background="transparent"
                    speed="0.8"
                    style={{ width: '180px', height: '277px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container2">
                <dotlottie-player
                    ref={el => animationRef.current[2] = el}
                    src="https://lottie.host/ef8ca5d4-08bc-4f4c-85b0-63b4c12bef43/jt0pYwK00Y.json"
                    background="transparent"
                    speed="1"
                    style={{ width: '106px', height: '219px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container3">
                <dotlottie-player
                    ref={el => animationRef.current[3] = el}
                    src="https://lottie.host/a18a3aa6-3e73-4289-bb75-12be2f2d86fa/Bi4V4CAv7M.json"
                    background="transparent"
                    speed="1.3"
                    style={{ width: '92px', height: '219px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container4">
                <dotlottie-player
                    ref={el => animationRef.current[4] = el}
                    src="https://lottie.host/0ca841da-5e7f-41bf-af0e-3b131815857d/3jJq7FHRpk.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '185px', height: '485px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container5">
                <dotlottie-player
                    ref={el => animationRef.current[5] = el}
                    src="https://lottie.host/c075a312-1a20-471c-ae96-02de55fb154f/yTvvmB9o5b.json"
                    background="transparent"
                    speed="0.5"
                    style={{ width: '140px', height: '528px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container6">
                <dotlottie-player
                    ref={el => animationRef.current[6] = el}
                    src="https://lottie.host/d552010e-2a93-46fa-bd36-9a335986c941/02uA55p797.json"
                    background="transparent"
                    speed="0.5"
                    style={{ width: '371.5px', height: '12px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container7">
                <dotlottie-player
                    ref={el => animationRef.current[7] = el}
                    src="https://lottie.host/d50e6e1f-8fb8-45e1-9134-8d8c0c782d34/BXtmN4gWm2.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '91px', height: '155px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container8">
                <dotlottie-player
                    ref={el => animationRef.current[8] = el}
                    src="https://lottie.host/bd60766a-d542-4a06-bdcb-5c08c66bb283/eGwIxrRATB.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '60.25px', height: '55px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
            <div className="animation-container9">
                <dotlottie-player
                    ref={el => animationRef.current[9] = el}
                    src="https://lottie.host/8f99f828-8674-4820-8196-7557c9c92727/cj6sPZZOaq.json"
                    background="transparent"
                    speed="1.2"
                    style={{ width: '137px', height: '319px' }}
                    loop={false}
                    autoplay={true}
                ></dotlottie-player>
            </div>
        </div>
      
    )
}

export default Connexion;

